import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { HeaderActionEventFromHeader, ORDER_FORM_HEADER_EVENTS } from './order-form-header-events.model';

/**
 * Order Form ← Header action consumer.
 * Listens for header user actions (e.g. close).
 */
@Service({ autoProvided: false })
export class OrderFormHeaderEventConsumerService {
	private readonly eventBus = inject(EventBusService);

	readonly headerAction$ = this.eventBus
		.on$<HeaderActionEventFromHeader>(ORDER_FORM_HEADER_EVENTS.HEADER_ACTION)
		.pipe(
			filter(Boolean),
			distinctUntilChanged((prev, curr) => prev.id === curr.id)
		);
}
